<div class="row h-100">
  <div class="col-9">
    <div class="row">
      <div class="col-lg-4 col-12">
        <label for="themes" class="form-label">Theme</label>
        <ng-select id="themes" [items]="themeList" [addTag]="addTheme" [clearable]="false" [(ngModel)]="question.theme" placeholder="Choose Theme" [ngModelOptions]="{standalone: true}">
          <ng-template ng-label-tmp let-item="item">
            <span>{{ 'LISTS.THEMES.' + item | translate: { Default: item } }}</span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
            <span>{{ 'LISTS.THEMES.' + item | translate: { Default: item } }}</span>
          </ng-template>
          <ng-template ng-tag-tmp let-search="searchTerm">
            <b>{{ 'GENERAL.Add item' | translate: { Default: 'Add item' } }}</b>: {{search}}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 col-12">
        <label for="thresholds" class="form-label">Threshold</label>
        <ng-select id="thresholds" [items]="thresholdList" [clearable]="false" [(ngModel)]="question.threshold" placeholder="Choose Threshold" [ngModelOptions]="{standalone: true}"></ng-select>
      </div>
      <div class="col-lg-2 col-12">
        <div class="row">
          <div class="col-12">
            <label for="time_limit" class="form-label">Time limit <i class="ri-information-fill text-info align-bottom" [ngbTooltip]="time_limit_tooltip" placement="bottom"></i></label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="input-step">
              <button type="button" class="minus shadow" (click)="decrement('time_limit')">-</button>
              <input id="time_limit" type="number" class="product-quantity" [(ngModel)]="question.time_limit" min="0">
              <button type="button" class="plus shadow" (click)="increment('time_limit')">+</button>
            </div>
            <div [ngClass]="{ 'd-block': submitted && question.time_limit < 0 }" class="invalid-feedback"> Must be positive number </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-12">
        <div class="row">
          <div class="col-12">
            <label for="count_down" class="form-label">Count Down <i class="ri-information-fill text-info align-bottom" [ngbTooltip]="count_down_tooltip" placement="bottom"></i></label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="input-step">
              <button type="button" class="minus shadow" (click)="decrement('count_down')">-</button>
              <input id="count_down" type="number" class="product-quantity" [(ngModel)]="question.count_down" min="0">
              <button type="button" class="plus shadow" (click)="increment('count_down')">+</button>
            </div>
            <div [ngClass]="question.count_down < 0 ? 'd-block' : ''" class="invalid-feedback"> Must be positive number </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-3">
    <label for="responseType" class="form-label">Response Type <span class="text-danger">*</span></label>
    <ng-select id="responseType" [items]="responseTypesList" [clearable]="false" [(ngModel)]="question.response.response_type" placeholder="Choose Response Type" [ngClass]="{ 'is-invalid': submitted && !question.response.response_type }" (ngModelChange)="reposponseTypeChange()" [ngModelOptions]="{standalone: true}"></ng-select>
    <div class="invalid-feedback"> Please select a response type </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-9">
    <label for="{{ questionID }}" class="form-label">Question Body @if (!checkQuestionBodyValidity(question.body)) {
      <span class="text-danger">* {{ submitted ? 'Please fill a valid question content' : '' }}</span>
    }</label>
    <quill-editor id="{{ questionID }}" [placeholder]="'Insert question content here...'" [styles]="{height: '250px'}" [(ngModel)]="question.body.question" [ngModelOptions]="{standalone: true}" class="d-block"></quill-editor>

    <label for="min_label" class="mt-2 form-label">
      Link <span class="text-danger"></span><i class="ri-information-fill align-bottom text-info" [ngbTooltip]="linkTips" placement="auto"></i>
      <span class="text-warning ms-3">**Make sure that the question time limit is greater then the video/audio length </span>
    </label>
    <div class="input-group">
      <input type="text" class="form-control me-2" [(ngModel)]="question.body.link_url" id="link-url" placeholder="Enter link here" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && !checkQuestionBodyValidity(question.body) }">
      <ng-select id="link_type" [items]="linkTypes" [dropdownPosition]="'top'" [searchable]="false" [clearable]="false" [(ngModel)]="question.body.link_type" placeholder="Choose Link Type" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && question.body.link_url && !question.body.link_type }"></ng-select>
    </div>
  </div>
  <div class="col-3">
    @if (question.response.response_type === 'RANGE') {
      <div class="mb-3">
        @if (question.response.response_range) {
          <div class="row mb-2">
            <div class="col-lg-8 col-12">
              <label for="min_label" class="form-label">Min Label <span class="text-danger">*</span></label>
              <input id="min_label" type="text" class="form-control" [(ngModel)]="question.response.response_range.range_label_min" placeholder="Min" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && !question.response.response_range.range_label_min }">
              <div class="invalid-feedback"> Please enter valid minimum label </div>
            </div>
            <div class="col-lg-4 col-12 ps-lg-1">
              <label for="min" class="form-label">Min <span class="text-danger">*</span></label>
              <input id="min" type="number" class="form-control" [(ngModel)]="question.response.response_range.range_min" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && question.response.response_range.range_max <= question.response.response_range.range_min }">
            </div>
          </div>
        }
        @if (question.response.response_range) {
          <div class="row">
            <div class="col-lg-8 col-12">
              <label for="max_label" class="form-label">Max Label <span class="text-danger">*</span></label>
              <input id="max_label" type="text" class="form-control" [(ngModel)]="question.response.response_range.range_label_max" placeholder="Max" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && !question.response.response_range.range_label_max }">
              <div class="invalid-feedback"> Please enter valid maximum label </div>
              <div [ngClass]="submitted && question.response.response_range.range_max <= question.response.response_range.range_min ? 'd-block invalid-feedback' : 'd-none'"> Minimum must be low than maximum </div>
            </div>
            <div class="col-lg-4 col-12 ps-lg-1">
              <label for="max" class="form-label">Max <span class="text-danger">*</span></label>
              <input id="max" type="number" class="form-control" [(ngModel)]="question.response.response_range.range_max" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && question.response.response_range.range_max <= question.response.response_range.range_min }">
            </div>
          </div>
        }
      </div>
    }
    @if (question.response.response_type === 'VOICE') {
      <div class="mb-3">
        @if (question.response.response_voice) {
          <div class="row mb-2">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <label for="count_down" class="form-label">Max Recording Time <i class="ri-information-fill text-info align-bottom" [ngbTooltip]="record_sec_tooltip" placement="bottom"></i></label>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="input-step">
                    <button type="button" class="minus shadow" (click)="decrement('voice_record_sec')">-</button>
                    <input id="count_down" type="number" class="product-quantity" [(ngModel)]="question.response.response_voice.record_sec" min="0">
                    <button type="button" class="plus shadow" (click)="increment('voice_record_sec')">+</button>
                  </div>
                  <div [ngClass]="{ 'd-block': submitted && question.response.response_voice.record_sec < 0 }" class="invalid-feedback"> Must be positive number </div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (question.response.response_voice) {
          <div class="row mb-2">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <label for="count_down" class="form-label">Start Auto Recording <i class="ri-information-fill text-info align-bottom" [ngbTooltip]="auto_recording_tooltip" placement="bottom"></i></label>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="input-step">
                    <button type="button" class="minus shadow" (click)="decrement('voice_time_to_start')">-</button>
                    <input id="count_down" type="number" class="product-quantity" [(ngModel)]="question.response.response_voice.time_to_start" min="0">
                    <button type="button" class="plus shadow" (click)="increment('voice_time_to_start')">+</button>
                  </div>
                  <div [ngClass]="{ 'd-block': submitted && question.response.response_voice.time_to_start < 0 }" class="invalid-feedback"> Must be positive number </div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (question.response.response_voice) {
          <div class="row mb-2">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <label for="count_down" class="form-label">Count Down Auto <i class="ri-information-fill text-info align-bottom" [ngbTooltip]="count_down_auto_recording_tooltip" placement="bottom"></i></label>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="input-step">
                    <button type="button" class="minus shadow" (click)="decrement('voice_alert_before')">-</button>
                    <input id="count_down" type="number" class="product-quantity" [(ngModel)]="question.response.response_voice.alert_before" min="0">
                    <button type="button" class="plus shadow" (click)="increment('voice_alert_before')">+</button>
                  </div>
                  <div [ngClass]="{ 'd-block': submitted && question.response.response_voice.alert_before < 0 }" class="invalid-feedback"> Must be positive number </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (question.response.response_type === 'SELECT') {
      <div class="my-2">
        <div class="form-check form-check-success mb-3">
          <input class="form-check-input" type="checkbox" id="multiselect" [checked]="question.response.response_select!.multi_select" (change)="checkedMultiselect()">
          <label class="form-check-label" for="multiselect"> Enable multi-select </label>
        </div>
        <label for="placeholderInput" class="form-label mt-1">Option Label</label>
        <div class="input-group">
          <input type="text" class="form-control" [(ngModel)]="option" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': optionSubmit && optionError }">
          <button type="button" class="btn btn-outline-success add-btn ms-1" (click)="addEditOption()">{{ editOptionMode ? 'Update' : 'Add' }}</button>
          <div class="invalid-feedback"> Please enter valid option label </div>
          <div [ngClass]="submitted && question.response.response_select!.response_options.length < 2 ? 'd-block invalid-feedback' : 'd-none'"> Response Type 'SELECT' must have at least 2 options </div>
        </div>
      </div>
    }
    <ngx-simplebar class="file-manager-response-option-scroll">
      @if (question.response.response_type === 'SELECT') {
        <div class="mb-3">
          <ul class="list-group">
            @for (option of question.response.response_select!.response_options; track option; let o = $index) {
              <li class="list-group-item d-flex justify-content-between align-items-center">
                {{ option.label }}
                <div class="btn-group">
                  <button type="button" class="btn btn-sm btn-primary add-btn ms-1" (click)="editOption(o)"><i class="ri-edit-2-line"></i></button>
                  <button type="button" class="btn btn-sm btn-danger add-btn ms-1" (click)="deleteOption(o)"><i class="ri-delete-bin-5-line"></i></button>
                </div>
              </li>
            }
          </ul>
        </div>
      }
    </ngx-simplebar>
  </div>
</div>

<ng-template #linkTips>
  <div class="d-flex flex-column">
    <span>Support direct video/audio public links.</span>
    <span>Youtube links should be exactly like that: https://www.youtube-nocookie.com/embed/XXX - XXX is the ID of the video in youtube.</span>
    <span>Make sure to see the result on the summary page for review your link results.</span>
  </div>
</ng-template>